<template>
  <div>
    <div class="row">
      <div class="col flex-grow-0">
        <div class="items-per-page">
          <label class="per-page">
            <select
              class="form-control input-sm"
              @change="changeLimit"
            >
              <option v-for="option in showOptions"
                      :key="option"
                      :value="option"
                      :selected="option == limit">
                Show {{ option }}
              </option>
            </select>
          </label>
        </div>
      </div>
      <div class="col text-right" v-if="!hideSearch">
        <div class="form-group form-inline">
          <slot name="filter">
            <slot name="additional-filter"></slot>
            <input
              type="text"
              class="search-input form-control pull-right"
              :placeholder="placeholder"
              :value="search"
              @input="onAsyncInputChange"
            >
          </slot>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-bordered" v-if="value && value.length">
            <thead>
            <tr>
              <th
                v-for="column in columns"
                @click="changeSort(column)"
                :key="column.field"
                class="sorting"
                :class="{
                  sorting_desc: descending && column.field === sortBy,
                  sorting_asc: !descending && column.field === sortBy,
                }"
              >
                {{column.title}}
              </th>
            </tr>
            </thead>
              <draggable class="sortable" v-if="orderable" :list="value" @change="onOrderChanged($event)" :element="'tbody'">
                <tr v-for="row in value" :key="row.id">
                  <td v-for="column in columns" :key="column.field">
                    <slot :name="column.field" :row="row">
                      {{ get(row, column.field, null) }}
                    </slot>
                  </td>
                </tr>
              </draggable>
              <tr v-else v-for="row in value" :key="row.id">
                <td v-for="column in columns" :key="column.field">
                  <slot :name="column.field" :row="row">
                    {{ get(row, column.field) }}
                  </slot>
                </td>
              </tr>
          </table>
          <div class="text-center no-data-label" v-if="!value || !value.length">
            <i>Nothing to show</i>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col mt-3">
        <pagination
          class="float-right"
          :page="page"
          :perPage="limit"
          :recordsTotal="meta.count"
          @page="changePage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash';
import Draggable from 'vuedraggable';
import Pagination from '@/components/Pagination';
import AsyncInputMixin from '@/mixins/AsyncInput';

export default {
  components: { Pagination, Draggable },
  mixins: [AsyncInputMixin('changeSearch')],
  props: {
    placeholder: String,
    columns: Array,
    hideSearch: Boolean,
    value: Array,
    limit: Number,
    page: Number,
    meta: {
      type: Object,
      default: () => ({})
    },
    orderable: {
      type: Boolean,
      default: false,
    },
    search: String
  },
  data() {
    return {
      showOptions: [10, 25, 50, 100],
      sortBy: this.orderable ? 'order' : 'created',
      descending: !this.orderable,
    };
  },
  methods: {
    get,
    changeSearch(event) {
      this.$emit('change', event.target.value);
    },
    changePage(page) {
      this.$emit('page', page);
    },
    changeLimit(limit) {
      this.$emit('limit', limit);
    },
    onOrderChanged(event) {
      this.$emit('ordered', event);
    },
    changeSort(column) {
      this.$emit('sort', column);
    }
  }
};
</script>
<style scoped lang="scss">
.per-page {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
}

.per-page select {
  width: 120px;
  display: inline-block !important;
}

.table-body {
  margin-top: 10px;
}

.search-input {
  min-width: 226px;
}

.sorting {
  cursor: pointer;
  white-space: nowrap;

  &::after {
    bottom: 8px;
    right: 2px;
    opacity: 0.5;

    display: inline-block;
    font: normal normal normal 24px/1 'Material Design Icons';
    font-size: inherit;
    text-rendering: auto;
    line-height: inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

.sorting_asc::after {
  content: '\F4BC';
}

.sorting_desc::after {
  content: '\F4BD';
}

.container.padding-less {
  padding-left: 0;
  padding-right: 0;
}
.table-responsive > .table-bordered {
  border: 1px solid #dee2e6 !important;
}

.no-data-label {
  position: absolute;
  width: 100%;
}

.clickable {
  cursor: pointer;
}

.form-inline {
  display: inline-block;
}

.flex-grow-0 {
  flex-grow: 0;
}
.sortable {
  td {
    cursor: move; /* fallback if grab cursor is unsupported */
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Grid.vue